<template>
  <div class="block-v">
    <div class="block-v__content">
      <div class="block-v__left">
        <div class="block-v__title" data-aos="fade-up">Буржуа</div>
        <div class="block-v__slider">
          <div class="swiper-container swiper-gallery-1">
            <div class="swiper-wrapper">
              <div class="swiper-slide"><img src="../assets/img/v-m-1.jpg" alt=""></div>
              <div class="swiper-slide"><img src="../assets/img/v-m-2.jpg" alt=""></div>
              <div class="swiper-slide"><img src="../assets/img/v-m-3.jpg" alt=""></div>
              <div class="swiper-slide"><img src="../assets/img/v-m-4.jpg" alt=""></div>
            </div>
          </div>
        </div>
        <div class="block-v__image block-v__image--1 rellax" data-rellax-speed="-0.4" data-rellax-percentage="0.4">
          <img src="../assets/img/block-v-1.jpg" alt="">
        </div>
        <div class="block-v__image block-v__image--2 rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4" id="block-v">
          <img src="../assets/img/block-v-2.gif" alt="">
        </div>
        <div class="block-v__text block-v__text--1 text text-white" data-aos="fade-up">Вызывающая роскошь и граничащая с безумством вседозволенность ревущих двадцатых дерзко проявляла себя в оглушительной на тот момент откровенности вечерних платьев: мало того, что они стали короче, обнажив икры и щиколотки чуть ли не до самого колена, так ещё и куда-то подевались столь внятно намекавшие раньше на требуемую дистанцию корсеты. Почти прозрачные, сплошь вышитые стеклярусом и бисером, они смущали всякого смотрящего, сами по себе являясь криком грядущих перемен.</div>
      </div> 
      <div class="block-v__right">
        <div class="block-v__text text text-white" data-aos="fade-up">Они господствовали, они обладали. Буржуазия была неизбежной данностью эпохи, в которой люди ради гедонизма были готовы на всё. В то время как, по мнению Вертинского, его друзья-футуристы только и делали, что «эпатировали буржуа, писали заумные стихи <br>и притворялись гениями», Вертинский поступал намного хитрее: вместо того, чтобы притворяться гением, <br>он просто был им. Как истинный представитель богемы, <br>с буржуазией он имел довольно сложные отношения, <br>но они в ответ его любили. Особенно за рубежом. </div>
        <div class="block-v__quote" data-aos="fade-up">
          <p>„Все продолжали жить своими интересами: издавали сборники стихов, грызлись между собой, эпатировали буржуа, писали заумные стихи, выставляли <br>на выставках явно издевательские полотна <br>и притворялись гениями“</p>
          <p class="block-v__quote-author">Вертинский А. <br>„Дорогой длинною...“</p>
        </div>
        <div class="block-v__image block-v__image--3 rellax" data-rellax-speed="-0.4" data-rellax-percentage="0.4">
          <img src="../assets/img/block-v-1-m.jpg" alt="">
        </div>
        <div class="block-v__image block-v__image--4 rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4" id="block-v">
          <img src="../assets/img/block-v-2.gif" alt="">
        </div>
        <div class="block-v__letter letter letter-white" data-aos="fade-up">
          В.
        </div>
        <div class="block-v__subtitle" data-aos="fade-up">ВСЕдозволенность </div>
        <div class="block-v__text block-v__text--3 text text-white" data-aos="fade-up">Вызывающая роскошь и граничащая с безумством вседозволенность ревущих двадцатых дерзко проявляла себя в оглушительной на тот момент откровенности вечерних платьев: мало того, что они стали короче, обнажив икры и щиколотки чуть ли не до самого колена, так ещё и куда-то подевались столь внятно намекавшие раньше на требуемую дистанцию корсеты. Почти прозрачные, сплошь вышитые стеклярусом и бисером, они смущали всякого смотрящего, сами по себе являясь криком грядущих перемен.</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
export default {
  name: 'BlockV',
  mounted() {
    new Swiper('.swiper-gallery-1', {
      loop: true,
     autoplay: {
       delay: 2500,
     },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
    });
  }
}
</script>

<style lang="sass">
  .bg-red
    background-color: #740D0C
    position: relative
    @media screen and (max-width: 999px)
      margin-top: vwm(252px)
    &:after
      content: ''
      width: 100%
      height: 100%
      background-image: url(../assets/img/noise.gif)
      background-size: 10vw
      position: absolute
      top: 0
      left: 0
      opacity: 0.1
    &:before
      content: ''
      width: 1px
      height: 100%
      background-color: #fff
      position: absolute
      top: 0
      right: 0
      left: 0
      margin: auto
      @media screen and (max-width: 999px)
        display: none !important
  .block-v
    padding-top: vw(27px)
    padding-bottom: vw(95px)
    &__slider
      display: none
      @media screen and (max-width: 999px)
        display: block
        width: 100vw
        height: vwm(257px)
        background-image: url(../assets/img/lenta-m.png)
        background-repeat: no-repeat
        background-size: 100vw
      img
        width: vwm(337px)
        margin-top: vwm(21px)
        margin-left: auto
        margin-right: auto
        display: block
    &__content
      display: flex
      position: relative
      z-index: 10
      padding-left: vw(66px)
      @media screen and (max-width: 999px)
        padding-left: 0
        flex-direction: column
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      text-align: right
      margin-right: vw(21px)
      margin-bottom: vw(63px)
      @media screen and (max-width: 999px)
        color: #000
        margin-top: vwm(-83px)
        margin-left: vwm(130px)
        font-size: vwm(60px)
    &__subtitle
      font-size: vw(60px)
      font-family: 'ZnikomitNo25'
      margin-top: vw(36px)
      margin-left: -2px
      @media screen and (max-width: 999px)
        margin-top: vwm(37px)
        margin-left: vwm(19px)
        font-size: vwm(37px)
    &__image
      img
        width: 100%
      &--1
        width: vw(493px)
        position: relative
        @media screen and (max-width: 999px)
          display: none
        &:after
          content: ''
          width: vw(275px)
          height: vw(392px)
          background-size: contain
          background-repeat: no-repeat
          background-image: url(../assets/img/block-v-el.png)
          position: absolute
          left: vw(-66px)
          top: vw(-51px)
      &--2
        width: vw(336px)
        margin-left: auto
        margin-top: vw(-62px)
        position: relative
        z-index: 10
        @media screen and (max-width: 999px)
          display: none
      &--3
        display: none
        @media screen and (max-width: 999px)
          display: block
          width: vwm(332px)
          position: relative
          margin-top: vwm(58px)
          margin-left: vwm(24px)
          img
            width: 100%
        &:after
          content: ''
          width: vwm(212px)
          height: vwm(302px)
          background-size: contain
          background-repeat: no-repeat
          background-image: url(../assets/img/block-v-el-m.png)
          position: absolute
          left: vwm(-23px)
          top: vwm(-40px)
      &--4
        display: none
        @media screen and (max-width: 999px)
          display: block
          width: vwm(276px)
          position: relative
          margin-top: vwm(-18px)
          margin-left: vwm(177px)
          img
            width: 100%
    &__left
      width: 50%
      min-width: 50%
      padding-right: vw(64px)
      .block-v__text
        margin-left: auto
        text-align: right
        margin-top: vw(18px)
        margin-right: vw(30px)
    &__right
      width: 50%
      min-width: 50%
      padding-top: vw(21px)
      .block-v__text
        margin-left: vw(46px)
    &__quote
      font-size: vw(50px)
      line-height: vw(44px)
      font-family: 'Aphrosine'
      color: #E1C99C
      font-style: italic
      text-align: right
      margin-top: vw(43px)
      margin-right: vw(46px)
      @media screen and (max-width: 999px)
        font-size: vwm(50px)
        width: 96vw
        margin: auto
        text-align: center
        margin-top: vwm(37px)
        line-height: vwm(40px)
        margin-left: 2vw
        letter-spacing: vwm(-0.7px)
        br
          display: none
      &-author
        color: #fff
        font-size: vw(38px)
        line-height: vw(35px)
        padding-right: vw(25px)
        margin-top: vw(38px)
        @media screen and (max-width: 999px)
          font-size: vwm(38px)
          line-height: vwm(35px)
          padding-right: vwm(25px)
          margin-top: vwm(38px)
          margin-left: vwm(94px)
          margin-right: vwm(-100px)
          br
            display: block
    &__letter
      margin-top: vw(-102px)
      margin-left: vw(13px)
      padding-left: vw(25px) 
      padding-top: vw(14px)
      @media screen and (max-width: 999px)
        margin-top: vwm(-135px)
        margin-left: vwm(18px)
        padding-top: vwm(0px)
        line-height: vwm(153px)
        padding-left: vwm(20px)
        font-size: vwm(144px)
    &__text
      @media screen and (max-width: 999px)
        margin-left: vwm(20px) !important
        width: 90vw
        margin-top: vwm(51px) !important
        line-height: vwm(23px) !important
        br
          display: none
      &--1
        @media screen and (max-width: 999px)
          display: none
      &--3
        display: none
        @media screen and (max-width: 999px)
          display: block
</style>
